import { ReactTFC } from "../../../../utils/fp/missing-ts-parts";
import { NewsletterLandingPageDataData } from "@swo/storefront";
import { ContentContainer } from "../../../../components/_shared-components/arrangement/Container";

import { css } from "@emotion/react";

import { PageHeadline } from "../../../../components/_shared-components/ui-elements/PageHeadline";
import { Spacer } from "../../../../components/_shared-components/arrangement/Space";
import { SignUpForm } from "./form/newsletter-landing-page-sign-up-form";
import React from "react";
import { paragraphStyles, wrapperStyles } from "../newsletter-landing-page-component";
import type { TranslatedValue } from "@swo/storefront";
export const RegisterState: ReactTFC<{
  countries: NewsletterLandingPageDataData["countries"];
  languages: NewsletterLandingPageDataData["languages"];
  currentLanguageIsoCode: string;
  currentCountryIsoCode: string;
  currentSegment: string;
  segmentLabels: { birding: TranslatedValue; hunting: TranslatedValue; outdoor: TranslatedValue };

  maybeInitialEmailValue: string | undefined;
  headline: React.ReactNode;
  paragraph: React.ReactNode;
  signUpTermsParagraph: React.ReactNode;
  segmentSelectorHeadline: React.ReactNode;
  buttonLabel: React.ReactNode;
  termsAndConditions: { link: string; label: TranslatedValue };
  otherConditions: { link: string; label: TranslatedValue };
  translations: { iAccept: TranslatedValue; and: TranslatedValue };
  onSignedUp: () => void;
}> = props => {
  return (
    <ContentContainer
      className={"expand"}
      attachStyles={css`
        // provide some white background while cart state is being resolved
        // this prevents footer from jumping heavily
        min-height: 60vh;
      `}
    >
      <PageHeadline>{props.headline}</PageHeadline>

      <hr
        css={css`
          width: 100%;
          height: 1px;
          background-color: black;
          border: none;
          margin: 0;
        `}
      />

      <Spacer size={"md"} />

      <div css={wrapperStyles}>
        <p css={paragraphStyles}>{props.paragraph}</p>

        <SignUpForm
          maybeInitialEmailValue={props.maybeInitialEmailValue}
          signUpTermsParagraph={props.signUpTermsParagraph}
          segmentSelectorHeadline={props.segmentSelectorHeadline}
          segmentLabels={props.segmentLabels}
          buttonLabel={props.buttonLabel}
          termsAndConditions={props.termsAndConditions}
          otherConditions={props.otherConditions}
          translations={{ ...props.translations, placeholderLabel: "E-mail" }}
          onSignedUp={props.onSignedUp}
          countries={props.countries}
          languages={props.languages}
          currentSegment={props.currentSegment}
          currentLanguageIsoCode={props.currentLanguageIsoCode}
          currentCountryIsoCode={props.currentCountryIsoCode}
        />
      </div>
    </ContentContainer>
  );
};
